import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "sentira_admin_jwt";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT automatically for admin calls
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---------- Public ----------
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitDemoRequest = (data) => api.post("/demo-request", data).then((r) => r.data);
export const submitApplication = (data) => api.post("/careers/apply", data).then((r) => r.data);
export const fetchFaq = () => api.get("/faq").then((r) => r.data.items);
export const fetchJobs = () => api.get("/careers/jobs").then((r) => r.data.jobs);
export const fetchContent = () => api.get("/content").then((r) => r.data);

// ---------- Auth ----------
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/admin/me").then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  api.post("/admin/change-password", { current_password, new_password }).then((r) => r.data);

// ---------- Admin: submissions ----------
export const fetchSubmissions = () => api.get("/admin/submissions").then((r) => r.data);

// ---------- Admin: content ----------
export const fetchAdminContent = () => api.get("/admin/content").then((r) => r.data);
export const updateContent = (data) => api.put("/admin/content", data).then((r) => r.data);

// ---------- Admin: FAQs ----------
export const adminListFaqs = () => api.get("/admin/faqs").then((r) => r.data.items);
export const adminCreateFaq = (data) => api.post("/admin/faqs", data).then((r) => r.data);
export const adminUpdateFaq = (id, data) => api.put(`/admin/faqs/${id}`, data).then((r) => r.data);
export const adminDeleteFaq = (id) => api.delete(`/admin/faqs/${id}`).then((r) => r.data);

// ---------- Admin: Jobs ----------
export const adminListJobs = () => api.get("/admin/jobs").then((r) => r.data.jobs);
export const adminCreateJob = (data) => api.post("/admin/jobs", data).then((r) => r.data);
export const adminUpdateJob = (id, data) => api.put(`/admin/jobs/${id}`, data).then((r) => r.data);
export const adminDeleteJob = (id) => api.delete(`/admin/jobs/${id}`).then((r) => r.data);
